import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Sidebar';
import verificandoApp from '../../../FuncoesGerais/verificaApp';
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import { fetchEmpresas, createEmpresa, updateEmpresa, fetchHorarioEmpresa, salvarHorarioEmpresa, fetchFeriadosEmpresa, adicionarFeriadoEmpresa, removerFeriadoEmpresa, solicitarRecalculoSla } from '../../../api/empresas';
import axios from 'axios';
import { ensureProtocol } from '../../../config/backend';
import './empresas.css';

function Empresas() {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [id, setId] = useState('');
  const [nome, setNome] = useState('');
  const [ativo, setAtivo] = useState(1);
  const [iaHabilitada, setIaHabilitada] = useState(1);
  const [iaCreditosLimite, setIaCreditosLimite] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [filtroAtivo, setFiltroAtivo] = useState('todos');
  const formCardRef = useRef(null);
  const isSoftbridge = localStorage.getItem('isSoftbridge') === 'S';
  const [statusDisponiveis, setStatusDisponiveis] = useState([]);
  const [etapasSelecionadas, setEtapasSelecionadas] = useState({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [], EM_TESTE: [] });
  const [salvandoEtapas, setSalvandoEtapas] = useState(false);
  const [usaHorarioSla, setUsaHorarioSla] = useState(0);
  const [horaInicioPadrao, setHoraInicioPadrao] = useState('');
  const [horaFimPadrao, setHoraFimPadrao] = useState('');
  const [horaInicioAlmoco, setHoraInicioAlmoco] = useState('');
  const [horaFimAlmoco, setHoraFimAlmoco] = useState('');
  const [diasUteisPadrao, setDiasUteisPadrao] = useState('SEG-SEX');
  const [feriados, setFeriados] = useState([]);
  const [novoFeriadoData, setNovoFeriadoData] = useState('');
  const [novoFeriadoTipo, setNovoFeriadoTipo] = useState('FECHADO');
  const [novoFeriadoDescricao, setNovoFeriadoDescricao] = useState('');
  const [recalculandoSla, setRecalculandoSla] = useState(false);

  const verificar = async () => {
    const resultado = await verificandoApp('ATENDENTE');
    if (!resultado) history.push('/');
  };

  const load = async () => {
    if (!isSoftbridge) {
      setLoading(false);
      return;
    }
    setLoading(true);
    verificandoToken();
    try {
      const list = await fetchEmpresas();
      setData(list);
    } catch (e) {
      setMensagem(e?.response?.data?.message || 'Erro ao carregar empresas.');
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verificar();
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const limparForm = () => {
    setId('');
    setNome('');
    setAtivo(1);
    setIaHabilitada(1);
    setIaCreditosLimite('');
    setMensagem('');
    setEtapasSelecionadas({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [], EM_TESTE: [] });
    setUsaHorarioSla(0);
    setHoraInicioPadrao('');
    setHoraFimPadrao('');
    setHoraInicioAlmoco('');
    setHoraFimAlmoco('');
    setDiasUteisPadrao('SEG-SEX');
    setFeriados([]);
    setNovoFeriadoData('');
    setNovoFeriadoTipo('FECHADO');
    setNovoFeriadoDescricao('');
  };

  const handleEdit = (item) => {
    setId(item.id);
    setNome(item.nome || '');
    setAtivo(item.ativo != null ? Number(item.ativo) : 1);
    setIaHabilitada(item.ia_habilitada != null ? Number(item.ia_habilitada) : 1);
    setIaCreditosLimite(item.ia_creditos_limite != null && item.ia_creditos_limite !== '' ? String(item.ia_creditos_limite) : '');
    setShowForm(true);
    setMensagem('');
    setTimeout(() => {
      formCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
    carregarStatusEtapasEHorario(item.id);
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: token } : {};
  };

  const baseUrlAnalista = () => {
    const ip = localStorage.getItem('ipBackend2') || '';
    return ip ? ensureProtocol(ip) : '';
  };

  const carregarStatusEtapasEHorario = async (empresaId) => {
    if (!empresaId) {
      setStatusDisponiveis([]);
      setEtapasSelecionadas({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [] });
      setUsaHorarioSla(0);
      setHoraInicioPadrao('');
      setHoraFimPadrao('');
      setHoraInicioAlmoco('');
      setHoraFimAlmoco('');
      setDiasUteisPadrao('SEG-SEX');
      setFeriados([]);
      return;
    }
    verificandoToken();
    const baseUrl = baseUrlAnalista();
    try {
      const [respStatus, respEtapas, horario, listaFeriados] = await Promise.all([
        axios.get(baseUrl + '/status-chamado', { headers: getAuthHeaders() }),
        axios.get(baseUrl + `/empresas/${empresaId}/etapas-chamado`, { headers: getAuthHeaders() }),
        fetchHorarioEmpresa(empresaId).catch(() => null),
        fetchFeriadosEmpresa(empresaId).catch(() => []),
      ]);
      const listaStatus = Array.isArray(respStatus.data) ? respStatus.data : [];
      const normalizada = listaStatus.map((s) => ({
        id: s.id ?? s.ID ?? s.codigo_legado,
        codigo_legado: s.codigo_legado ?? s.CODIGO_LEGADO ?? s.codigo ?? s.CODIGO,
        nome: s.nome ?? s.NOME ?? String(s.codigo_legado ?? s.CODIGO_LEGADO ?? ''),
        conclusao: s.conclusao ?? s.CONCLUSAO ?? 0,
      })).filter((s) => s.codigo_legado != null && s.nome);
      setStatusDisponiveis(normalizada);
      const etapas = (respEtapas.data && respEtapas.data.etapas) || {};
      setEtapasSelecionadas({
        SUPORTE: Array.isArray(etapas.SUPORTE) ? etapas.SUPORTE : [],
        ANALISE: Array.isArray(etapas.ANALISE) ? etapas.ANALISE : [],
        DESENVOLVIMENTO: Array.isArray(etapas.DESENVOLVIMENTO) ? etapas.DESENVOLVIMENTO : [],
        EM_TESTE: Array.isArray(etapas.EM_TESTE) ? etapas.EM_TESTE : [],
      });
      if (horario && horario.empresa_id) {
        setUsaHorarioSla(horario.usa_horario_funcionamento_sla != null ? Number(horario.usa_horario_funcionamento_sla) : 0);
        setHoraInicioPadrao(horario.hora_inicio_padrao ? String(horario.hora_inicio_padrao).substring(0, 5) : '');
        setHoraFimPadrao(horario.hora_fim_padrao ? String(horario.hora_fim_padrao).substring(0, 5) : '');
        setHoraInicioAlmoco(horario.hora_inicio_almoco ? String(horario.hora_inicio_almoco).substring(0, 5) : '');
        setHoraFimAlmoco(horario.hora_fim_almoco ? String(horario.hora_fim_almoco).substring(0, 5) : '');
        setDiasUteisPadrao(horario.dias_uteis_padrao || 'SEG-SEX');
      } else {
        setUsaHorarioSla(0);
        setHoraInicioPadrao('');
        setHoraFimPadrao('');
        setHoraInicioAlmoco('');
        setHoraFimAlmoco('');
        setDiasUteisPadrao('SEG-SEX');
      }
      setFeriados(Array.isArray(listaFeriados) ? listaFeriados : []);
    } catch (e) {
      console.error('Erro ao carregar status/etapas da empresa:', e);
      setStatusDisponiveis([]);
      setEtapasSelecionadas({ SUPORTE: [], ANALISE: [], DESENVOLVIMENTO: [], EM_TESTE: [] });
      setUsaHorarioSla(0);
      setHoraInicioPadrao('');
      setHoraFimPadrao('');
      setHoraInicioAlmoco('');
      setHoraFimAlmoco('');
      setDiasUteisPadrao('SEG-SEX');
      setFeriados([]);
    }
  };

  const toggleEtapaStatus = (tipo, codigoLegado) => {
    setEtapasSelecionadas((prev) => {
      const atual = Array.isArray(prev[tipo]) ? prev[tipo] : [];
      const cod = typeof codigoLegado === 'number' ? codigoLegado : parseInt(String(codigoLegado), 10);
      if (Number.isNaN(cod)) return prev;
      const jaTem = atual.includes(cod);
      const novo = jaTem ? atual.filter((c) => c !== cod) : [...atual, cod];
      return { ...prev, [tipo]: novo };
    });
  };

  const salvarEtapasChamado = async () => {
    if (!id) {
      setMensagem('Salve a empresa antes de configurar as etapas do chamado.');
      return;
    }
    verificandoToken();
    const baseUrl = baseUrlAnalista();
    setSalvandoEtapas(true);
    try {
      await axios.put(
        baseUrl + `/empresas/${id}/etapas-chamado`,
        { etapas: etapasSelecionadas },
        { headers: getAuthHeaders() }
      );
    } catch (e) {
      console.error('Erro ao salvar etapas do chamado:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao salvar etapas do chamado desta empresa.');
    } finally {
      setSalvandoEtapas(false);
    }
  };

  const salvarHorario = async () => {
    if (!id) {
      setMensagem('Salve a empresa antes de configurar o horário de funcionamento.');
      return;
    }
    if (usaHorarioSla === 1 && (!horaInicioPadrao || !horaFimPadrao)) {
      setMensagem('Informe horário de início e fim para usar horário de funcionamento na SLA.');
      return;
    }
    if ((horaInicioAlmoco && !horaFimAlmoco) || (!horaInicioAlmoco && horaFimAlmoco)) {
      setMensagem('Para o intervalo de almoço, informe a saída e a volta (ou deixe ambos em branco).');
      return;
    }
    if (horaInicioAlmoco && horaFimAlmoco && horaFimAlmoco <= horaInicioAlmoco) {
      setMensagem('A volta do almoço deve ser após a saída para o almoço.');
      return;
    }
    try {
      await salvarHorarioEmpresa(id, {
        usa_horario_funcionamento_sla: usaHorarioSla,
        hora_inicio_padrao: horaInicioPadrao ? `${horaInicioPadrao}:00` : null,
        hora_fim_padrao: horaFimPadrao ? `${horaFimPadrao}:00` : null,
        hora_inicio_almoco: horaInicioAlmoco ? `${horaInicioAlmoco}:00` : null,
        hora_fim_almoco: horaFimAlmoco ? `${horaFimAlmoco}:00` : null,
        dias_uteis_padrao: diasUteisPadrao || null,
      });
      setMensagem('Horário de funcionamento salvo com sucesso.');
    } catch (e) {
      console.error('Erro ao salvar horário de funcionamento:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao salvar horário de funcionamento desta empresa.');
    }
  };

  const adicionarFeriado = async () => {
    if (!id) {
      setMensagem('Salve a empresa antes de configurar feriados.');
      return;
    }
    if (!novoFeriadoData) {
      setMensagem('Informe a data do feriado.');
      return;
    }
    try {
      await adicionarFeriadoEmpresa(id, {
        data: novoFeriadoData,
        tipo: novoFeriadoTipo,
        descricao: novoFeriadoDescricao || null,
      });
      setNovoFeriadoData('');
      setNovoFeriadoTipo('FECHADO');
      setNovoFeriadoDescricao('');
      const lista = await fetchFeriadosEmpresa(id);
      setFeriados(Array.isArray(lista) ? lista : []);
    } catch (e) {
      console.error('Erro ao adicionar feriado:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao adicionar feriado desta empresa.');
    }
  };

  const excluirFeriado = async (feriadoId) => {
    if (!id || !feriadoId) return;
    try {
      await removerFeriadoEmpresa(id, feriadoId);
      setFeriados((prev) => prev.filter((f) => f.id !== feriadoId));
    } catch (e) {
      console.error('Erro ao remover feriado:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao remover feriado desta empresa.');
    }
  };

  const dispararRecalculoSla = async () => {
    if (!id) {
      setMensagem('Selecione e salve a empresa antes de solicitar o recálculo de SLA.');
      return;
    }
    setRecalculandoSla(true);
    try {
      await solicitarRecalculoSla(id);
      setMensagem('Solicitação de recálculo de SLA registrada. Os próximos indicadores já considerarão o horário de funcionamento.');
    } catch (e) {
      console.error('Erro ao solicitar recálculo de SLA:', e);
      setMensagem(e?.response?.data?.error || 'Erro ao solicitar recálculo de SLA.');
    } finally {
      setRecalculandoSla(false);
    }
  };

  const salvar = async () => {
    if (!nome || !String(nome).trim()) {
      setMensagem('Nome da empresa é obrigatório.');
      return;
    }
    setMensagem('');
    verificandoToken();
    try {
      const payload = {
        nome: nome.trim(),
        ativo: Number(ativo),
        ia_habilitada: Number(iaHabilitada),
        ia_creditos_limite: (iaCreditosLimite === '' || iaCreditosLimite == null) ? null : Number(iaCreditosLimite),
      };
      if (id) {
        await updateEmpresa(id, payload);
      } else {
        const res = await createEmpresa(payload);
        const login = res?.login;
        setMensagem(login
          ? `Empresa criada. Usuário ${login} / tacoma123! disponível para implantação (uso exclusivo desta empresa).`
          : 'Empresa criada.');
      }
      limparForm();
      setShowForm(false);
      load();
    } catch (e) {
      setMensagem(e?.response?.data?.error || e?.response?.data?.message || 'Erro ao salvar.');
    }
  };

  const dataFiltrada = filtroAtivo === 'todos' ? data : data.filter((row) => (filtroAtivo === 'ativo' ? row.ativo : !row.ativo));

  if (!isSoftbridge) {
    return (
      <div className="app-layout">
        <Sidebar />
        <main className="main-content">
          <div className="empresas-page">
            <div className="sem-permissao">Apenas a empresa Softbridge pode acessar o cadastro de empresas.</div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo cadastro-unificado empresas-page">
          <div className="page-header">
            <h1>Empresas</h1>
            <div className="toolbar flex-wrap">
              <select value={filtroAtivo} onChange={(e) => setFiltroAtivo(e.target.value)} className="form-control form-control-sm" style={{ maxWidth: 140 }} title="Filtrar por status">
                <option value="todos">Todos</option>
                <option value="ativo">Ativos</option>
                <option value="inativo">Inativos</option>
              </select>
              <button type="button" className="btn btn-primary btn-sm" onClick={() => { limparForm(); setShowForm(true); setMensagem(''); }} style={{ display: showForm ? 'none' : 'inline-flex' }}>
                Nova empresa
              </button>
            </div>
          </div>
          {mensagem && (
            <div className={`msg ${mensagem.includes('Erro') ? 'erro' : 'sucesso'}`}>{mensagem}</div>
          )}
          {showForm && (
            <div ref={formCardRef} className="card card-form mb-3">
              <div className="card-body">
                <h5 className="card-title">{id ? 'Editar empresa' : 'Nova empresa'}</h5>
                <div className="row">
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group mb-2">
                      <label>Nome</label>
                      <input
                        type="text"
                        value={nome}
                        onChange={(e) => setNome(e.target.value)}
                        className="form-control form-control-sm"
                        placeholder="Nome da empresa"
                      />
                    </div>
                    <div className="form-group mb-2">
                      <label>Ativo</label>
                      <select value={ativo} onChange={(e) => setAtivo(Number(e.target.value))} className="form-control form-control-sm">
                        <option value={1}>Sim</option>
                        <option value={0}>Não</option>
                      </select>
                    </div>
                    <div className="form-group mb-2">
                      <label>IA habilitada</label>
                      <select value={iaHabilitada} onChange={(e) => setIaHabilitada(Number(e.target.value))} className="form-control form-control-sm" title="Recursos de IA (sugestões, resumo) para esta empresa">
                        <option value={1}>Sim</option>
                        <option value={0}>Não</option>
                      </select>
                    </div>
                    <div className="form-group mb-2">
                      <label>Limite de créditos IA (mensagens/mês)</label>
                      <input
                        type="number"
                        min={0}
                        step={1}
                        value={iaCreditosLimite}
                        onChange={(e) => setIaCreditosLimite(e.target.value)}
                        className="form-control form-control-sm"
                        placeholder="0 ou vazio = mensagens ilimitadas"
                        title="0 ou vazio = mensagens ilimitadas. Ex.: 500, 2000 para limite mensal."
                      />
                      <small className="text-muted">0 ou vazio = mensagens ilimitadas. Valor &gt; 0 = limite mensal de mensagens.</small>
                    </div>
                    <button type="button" className="btn btn-primary btn-sm me-2" onClick={salvar}>Salvar</button>
                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => { limparForm(); setShowForm(false); }}>Cancelar</button>
                  </div>
                  {id && (
                    <div className="col-md-6 col-lg-8 mt-3 mt-md-0">
                      <h6>Etapas do chamado para esta empresa</h6>
                      <p className="text-muted small">
                        Selecione, para esta empresa, quais <strong>status de chamado</strong> representam cada etapa:
                        <strong> Suporte normal</strong>, <strong>Análise de requisitos</strong>, <strong>Em desenvolvimento</strong> e <strong>Em teste</strong>.
                      </p>
                      <div className="row">
                        {['SUPORTE', 'ANALISE', 'DESENVOLVIMENTO', 'EM_TESTE'].map((tipo) => (
                          <div className="col-md-6 col-lg-3 mb-3" key={tipo}>
                            <div className="card h-100">
                              <div className="card-body p-2">
                                <h6 className="card-title mb-1">
                                  {tipo === 'SUPORTE' && 'Suporte normal'}
                                  {tipo === 'ANALISE' && 'Análise de requisitos'}
                                  {tipo === 'DESENVOLVIMENTO' && 'Em desenvolvimento'}
                                  {tipo === 'EM_TESTE' && 'Em teste'}
                                </h6>
                                <div className="empresas-etapas-status-lista">
                                  {statusDisponiveis.length === 0 && (
                                    <p className="text-muted small mb-0">Nenhum status carregado.</p>
                                  )}
                                  {statusDisponiveis.map((st) => {
                                    const cod = st.codigo_legado;
                                    const selecionados = etapasSelecionadas[tipo] || [];
                                    const marcado = selecionados.includes(cod) || selecionados.includes(Number(cod));
                                    return (
                                      <div className="form-check form-check-sm" key={`${tipo}-${cod}`}>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id={`emp-${id}-${tipo}-${cod}`}
                                          checked={marcado}
                                          onChange={() => toggleEtapaStatus(tipo, cod)}
                                        />
                                        <label className="form-check-label" htmlFor={`emp-${id}-${tipo}-${cod}`}>
                                          {st.nome} <span className="text-muted small">({cod})</span>
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm mt-1 mb-3"
                        onClick={salvarEtapasChamado}
                        disabled={salvandoEtapas}
                      >
                        {salvandoEtapas ? 'Salvando etapas...' : 'Salvar etapas do chamado desta empresa'}
                      </button>

                      <hr />
                      <h6>Horário de funcionamento / SLA</h6>
                      <p className="text-muted small">
                        Configure o horário de funcionamento da empresa. Quando a opção estiver ativada, a SLA será contada apenas dentro desse horário (horas úteis).
                      </p>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group mb-2">
                            <label>Usar horário de funcionamento na SLA</label>
                            <select
                              value={usaHorarioSla}
                              onChange={(e) => setUsaHorarioSla(Number(e.target.value))}
                              className="form-control form-control-sm"
                            >
                              <option value={0}>Não</option>
                              <option value={1}>Sim</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-2">
                            <label>Horário de início</label>
                            <input
                              type="time"
                              className="form-control form-control-sm"
                              value={horaInicioPadrao}
                              onChange={(e) => setHoraInicioPadrao(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-2">
                            <label>Saída p/ almoço</label>
                            <input
                              type="time"
                              className="form-control form-control-sm"
                              value={horaInicioAlmoco}
                              onChange={(e) => setHoraInicioAlmoco(e.target.value)}
                            />
                            <small className="text-muted">Opcional</small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-2">
                            <label>Volta do almoço</label>
                            <input
                              type="time"
                              className="form-control form-control-sm"
                              value={horaFimAlmoco}
                              onChange={(e) => setHoraFimAlmoco(e.target.value)}
                            />
                            <small className="text-muted">Opcional</small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-2">
                            <label>Horário de fim</label>
                            <input
                              type="time"
                              className="form-control form-control-sm"
                              value={horaFimPadrao}
                              onChange={(e) => setHoraFimPadrao(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-2">
                            <label>Dias úteis padrão</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={diasUteisPadrao}
                              onChange={(e) => setDiasUteisPadrao(e.target.value)}
                              placeholder="Ex.: SEG-SEX ou SEG-SAB"
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm mt-1"
                            onClick={salvarHorario}
                          >
                            Salvar horário de funcionamento
                          </button>
                        </div>
                      </div>

                      <hr />
                      <h6>Feriados e expedientes especiais</h6>
                      <p className="text-muted small">
                        Cadastre feriados (dia todo fechado) ou, futuramente, dias com horário reduzido. Esses dias não contam (ou contam parcialmente) para a SLA em horas úteis.
                      </p>
                      <div className="row align-items-end">
                        <div className="col-md-3">
                          <div className="form-group mb-2">
                            <label>Data</label>
                            <input
                              type="date"
                              className="form-control form-control-sm"
                              value={novoFeriadoData}
                              onChange={(e) => setNovoFeriadoData(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-2">
                            <label>Tipo</label>
                            <select
                              className="form-control form-control-sm"
                              value={novoFeriadoTipo}
                              onChange={(e) => setNovoFeriadoTipo(e.target.value)}
                            >
                              <option value="FECHADO">Fechado</option>
                              <option value="HORARIO_REDUZIDO">Horário reduzido</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group mb-2">
                            <label>Descrição</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={novoFeriadoDescricao}
                              onChange={(e) => setNovoFeriadoDescricao(e.target.value)}
                              placeholder="Ex.: Feriado municipal"
                            />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={adicionarFeriado}
                          >
                            Adicionar
                          </button>
                        </div>
                      </div>
                      <div className="table-responsive mt-2">
                        <table className="table table-sm table-striped mb-0">
                          <thead>
                            <tr>
                              <th>Data</th>
                              <th>Tipo</th>
                              <th>Descrição</th>
                              <th style={{ width: 60 }}>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(!feriados || feriados.length === 0) && (
                              <tr>
                                <td colSpan="4" className="text-muted small text-center">
                                  Nenhum feriado cadastrado.
                                </td>
                              </tr>
                            )}
                            {feriados && feriados.map((f) => (
                              <tr key={f.id}>
                                <td>{f.data ? String(f.data).substring(0, 10) : ''}</td>
                                <td>{f.tipo}</td>
                                <td>{f.descricao || ''}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-link btn-sm text-danger p-0"
                                    title="Remover"
                                    onClick={() => excluirFeriado(f.id)}
                                  >
                                    <i className="fas fa-trash" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      <hr />
                      <h6>Recalcular SLA histórico</h6>
                      <p className="text-muted small">
                        Use este botão quando ajustar o horário de funcionamento ou feriados da empresa. Os indicadores de SLA e tempo médio são calculados em tempo real; esta ação apenas força a validação da configuração e registra a intenção de recalcular.
                      </p>
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={dispararRecalculoSla}
                        disabled={recalculandoSla}
                      >
                        {recalculandoSla ? 'Validando configuração de SLA...' : 'Recalcular SLA histórico'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="lista-wrapper">
            {loading ? (
              <p className="text-muted">Carregando...</p>
            ) : (
              <table className="table table-modern align-middle">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nome</th>
                    <th>Ativo</th>
                    <th>IA</th>
                    <th>Limite IA</th>
                    <th width="120">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {dataFiltrada.length === 0 && !loading && (
                    <tr><td colSpan="6" className="text-center text-muted">Nenhuma empresa cadastrada.</td></tr>
                  )}
                  {dataFiltrada.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.nome}</td>
                      <td><span className={row.ativo ? 'badge-pill badge-ativo' : 'badge-pill badge-inativo'}>{row.ativo ? 'Sim' : 'Não'}</span></td>
                      <td><span className={(row.ia_habilitada ?? 1) ? 'badge-pill badge-ativo' : 'badge-pill badge-inativo'}>{((row.ia_habilitada ?? 1) ? 'Sim' : 'Não')}</span></td>
                      <td>{row.ia_creditos_limite != null && row.ia_creditos_limite > 0 ? row.ia_creditos_limite : '—'}</td>
                      <td>
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleEdit(row)} title="Editar"><i className="fas fa-edit" /></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export default Empresas;
